var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFollowing = function SvgFollowing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.727 5.245a2.279 2.279 0 1 0 0-4.557 2.279 2.279 0 0 0 0 4.557M5.375 11.625H.625v-.494a4.11 4.11 0 0 1 4.287-4.063 4.1 4.1 0 0 1 1.96.605M7.802 10.844h5.073M10.969 12.75l1.906-1.906-1.906-1.906"
  }))));
};
export default SvgFollowing;